import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import BrandAvatar from './BrandAvatar';
import Button from './Button';

const ErrorView = ({ href, title, text, buttonLabel, onClickButton = () => null, className }) => {
  const cn = useClassNames(
    () => ['flex', 'flex-col', 'justify-center', 'items-center', 'h-full', className],
    [className],
  );

  return (
    <div className={cn}>
      <BrandAvatar size="16" />
      <h1 className="mt-6 text-2xl">{title}</h1>
      <p className="mt-2">{text}</p>
      <form action={href} className="mx-auto mt-8">
        <Button type="submit" onClick={onClickButton}>
          {buttonLabel}
        </Button>
      </form>
    </div>
  );
};

ErrorView.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClickButton: PropTypes.func,
};

export default ErrorView;
